
<q-tabs
  v-if="optionsProcessed.length !== 0"
  v-bind="$attrs"
  :value="value"
  :name="name"
  class="ws-btn-toggle"
  indicator-color="ws-white"
  v-on="$listeners"
  @input="onUpdate"
>
  <q-tab
    v-for="(option, i) in optionsProcessed"
    :key="option.value"
    :ripple="false"
    :data-test="`toggle-${option.value}`"
    :name="option.value"
    :label="option.label"
    :style="`width:${100 / optionsProcessed.length}%`"
    :class="{'with-badge': option.badgeValue !== undefined}"
    :disable="getDisabled(option, i)"
  >
    <q-badge v-if="option.badgeValue !== undefined" :class="option.badgeType.toLowerCase()">
      {{ option.badgeValue }}
    </q-badge>
    <ws-tooltip v-if="getDisabled(option, i) && get(option, 'disabledTooltip')">
      {{ option.disabledTooltip }}
    </ws-tooltip>
    <ws-tooltip v-else-if="get(option, 'tooltip')">
      {{ option.tooltip }}
    </ws-tooltip>
    <ws-icon v-if="option.icon" :name="option.icon"></ws-icon>
  </q-tab>
  <input :name="name" type="hidden" :value="value" />
</q-tabs>
